import { shorten } from 'projects/sharedComponents/src/services/stringFormatters/stringFormatters';

export function useShortPetName(name: string): string {
  return shorten(name, 25);
}
